import script from "./magnifyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./magnifyComponent.vue?vue&type=script&setup=true&lang=js"

import "./magnifyComponent.vue?vue&type=style&index=0&id=61d9f564&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d9f564"]])

export default __exports__